import { toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "sticky top-0 z-10 bg-white" }
const _hoisted_3 = ["aria-pressed"]
const _hoisted_4 = {
  class: "ml-auto h-4 w-4",
  focusable: "false",
  "aria-hidden": "true",
  width: "16",
  height: "16"
}
const _hoisted_5 = {
  class: "mr-5 h-3 w-3",
  focusable: "false",
  "aria-hidden": "true",
  width: "12",
  height: "12"
}
const _hoisted_6 = {
  key: 1,
  class: "flex items-center pb-10px"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = {
  style: {"width":"1em","height":"1em"},
  focusable: "false",
  "aria-hidden": "true",
  width: "16",
  height: "16"
}
const _hoisted_10 = ["id", "placeholder"]
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = {
  key: 0,
  class: "py-4 text-center text-ccc"
}
const _hoisted_13 = {
  key: 1,
  class: "divide-y relative divide-ccc pb-15"
}
const _hoisted_14 = {
  key: 2,
  class: "mb-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_vocabulary_component = _resolveComponent("filter-vocabulary-component")!
  const _component_filter_color_component = _resolveComponent("filter-color-component")!

  return (_ctx.kindVisible)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "search-toggle",
            "aria-pressed": _ctx.filterVisible ? 'true' : 'false',
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.t(_ctx.kind)) + " ", 1),
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-down' })), null, 16)
            ]))
          ], 8, _hoisted_3),
          (_ctx.filterVisible && _ctx.filterIsSet)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "mb-10px flex w-full items-center py-4 text-left leading-none",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-down' })), null, 16)
                ])),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('all')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.filterVisible && _ctx.kind !== 'COLOR')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", {
                  for: `filter-${_ctx.kind}`,
                  class: "mr-4 text-ccc"
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('search')), 1),
                  (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[5] || (_cache[5] = [
                    _createElementVNode("use", { "xlink:href": "#magnifier" }, null, -1)
                  ])))
                ], 8, _hoisted_7),
                _withDirectives(_createElementVNode("input", {
                  id: `filter-${_ctx.kind}`,
                  type: "search",
                  placeholder: _ctx.t('search'),
                  class: "w-full text-root",
                  autocomplete: "off",
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFilterInput && _ctx.handleFilterInput(...args))),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterTerm) = $event))
                }, null, 40, _hoisted_10), [
                  [_vModelText, _ctx.filterTerm]
                ]),
                (_ctx.filterTerm)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilterInput && _ctx.resetFilterInput(...args))),
                      class: "px-1 py-1",
                      type: "reset"
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('reset')), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("svg", {
                        focusable: "false",
                        "aria-hidden": "true",
                        class: "h-3 w-3",
                        width: "12",
                        height: "12"
                      }, [
                        _createElementVNode("use", { "xlink:href": "#close" })
                      ], -1))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.filterVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({ 'search-vocabulary-wrapper': _ctx.kind !== 'COLOR' })
            }, [
              (_ctx.kind !== 'COLOR' && _ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t('loading')) + "… ", 1))
                : _createCommentVNode("", true),
              (_ctx.kind !== 'COLOR')
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabularies, (vocabulary) => {
                      return (_openBlock(), _createBlock(_component_filter_vocabulary_component, {
                        key: `${_ctx.kind}-${vocabulary.id}`,
                        kind: _ctx.kind,
                        vocabulary: vocabulary,
                        "expanded-items": _ctx.expandedItems,
                        onExpandChildren: _ctx.fetchChildren
                      }, null, 8, ["kind", "vocabulary", "expanded-items", "onExpandChildren"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.kind === 'COLOR')
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allColors, (color) => {
                      return (_openBlock(), _createElementBlock("li", { key: color }, [
                        _createVNode(_component_filter_color_component, {
                          color: color,
                          disabled: !_ctx.colors.includes(color)
                        }, null, 8, ["color", "disabled"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}